import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectLivingArea = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('living_area')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
